export var getIds = id => id ? {
  root: "".concat(id, "__root"),
  cardLogo: "".concat(id, "__card-logo"),
  container: "".concat(id, "__container"),
  icon: "".concat(id, "__icon"),
  textWrapper: "".concat(id, "__text-wrapper"),
  label: "".concat(id, "__label"),
  input: id,
  loader: "".concat(id, "__loader"),
  obfuscatedValue: "".concat(id, "__obfuscated-value"),
  fieldLinkWrapper: "".concat(id, "__field-link-wrapper"),
  fieldLink: "".concat(id, "__field-link"),
  fieldTooltip: "".concat(id, "__field-tooltip")
} : undefined;
//# sourceMappingURL=getIds.js.map